/**
 * 「このマスターは別の場所がひとつの正本です」の案内カード。
 * 同じ表を2か所で編集できる状態をなくすため、製造のタブはここへ寄せる。
 */
export default function MasterLink({ title, body, to, linkLabel, testId }) {
  return (
    <div className="rounded-lg border border-zinc-200 bg-zinc-50 px-4 py-5" data-testid={testId}>
      <p className="text-sm font-semibold text-zinc-800">{title}</p>
      <p className="mt-1 text-xs leading-relaxed text-zinc-600">{body}</p>
      <a href={to}
        className="mt-3 inline-flex items-center rounded-md bg-teal-700 px-3 py-2 text-xs font-semibold text-white hover:bg-teal-800"
        data-testid={`${testId}-link`}>
        {linkLabel}
      </a>
    </div>
  );
}
